import React from 'react';

import { CloseOutlined } from '@ant-design/icons';
import { Tag } from 'antd';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { selectEventPopupDetails } from '../../../store/serviceCalendarSlice';
import dayjs from 'dayjs';

export const ServiceCalendarPopupShowEvent = ({ displayStyle, handleClose }) => {
    const navigate = useNavigate();
    const eventPopupDetails = useSelector(selectEventPopupDetails);

    // If no details in Redux, don't render
    if (!eventPopupDetails || !eventPopupDetails.event) {
        return null;
    }
    const {
        serviceId,
        vehicleId,
        vehicleMake,
        vehicleType,
        date,
        serviceType,
        serviceTypes,
        status,
        statusDetails,
        statusFull,
        supplier,
        vehicleReg,
        service,
        isScheduled,
        taskDescription,
        failDescription,
        locationType,
        workTicketId,
        recordType,
        type
    } = eventPopupDetails.event;
    const { left, top } = eventPopupDetails.position;

    const isDefect = recordType === 'Defect';
    const formattedDate = dayjs(date).local().format('YYYY-MM-DD');

    const handleEditService = () => {
        const serviceCategory = isDefect ? 'defect' : isScheduled ? 'scheduled' : 'unscheduled';
        const routeMap = {
            scheduled: '/scheduled-services',
            unscheduled: '/unscheduled-services',
            defect: '/defect-tickets'
        };

        navigate(`${routeMap[serviceCategory]}/add?id=${serviceId}&start_date=${formattedDate}&from=calendar`);
    };

    const handleViewTicket = () => {
        navigate(`/work-tickets/${workTicketId}`);
    };

    return (
        <div
            style={{
                width: '273px',
                // Height: "380px",
                display: displayStyle,
                left: `${left}px`,
                top: `${top}px`,
                position: 'absolute',
                background: 'white',
                border: '1px solid lightgrey',
                boxShadow: '5px 4px 4px rgba(10, 10, 10, 0.4)',
                zIndex: '1000'
            }}
            className="text-[13px] font-normal text-[#333333] font-['Roboto']">
            <div className="p-1 bg-[#3b8eb9] text-white flex justify-between items-center">
                <div className="font-bold text-sm">{isDefect ? 'Defect' : isScheduled ? 'Scheduled Service' : 'Unscheduled Service'}</div>
                <CloseOutlined onClick={handleClose} className="hover:bg-gray-500" />
            </div>
            <div style={{ width: '100%', padding: '10px' }}>
                <div className="flex flex-col gap-2">
                    {serviceTypes?.map((s, i) => (
                        <div
                            key={i}
                            style={{
                                width: '100%',
                                textAlign: 'center',
                                background: s.background_color,
                                border: '2px solid ' + s.border_color,
                                color: 'white',
                                fontWeight: 'bolder',
                                padding: '4px 8px 4px'
                            }}>
                            {s.service_type}
                        </div>
                    ))}
                </div>
                {isScheduled ? (
                    <div className={`mt-3 font-normal text-[13px] text-[#333333] font-['Roboto'] service-name-popup`} title={service}>
                        {service}
                    </div>
                ) : (
                    <div className={`mt-3 font-semibold text-[14px] text-[#333333] font-['Roboto'] service-name-popup`} title={service || type}>
                        {service || type}
                    </div>
                )}

                <div className="flex gap-[25px] mt-3 text-[13px]">
                    <div>Status</div>
                    <Tag
                        color={statusDetails?.background_color}
                        style={{
                            background: statusDetails?.background_color,
                            border: '1px solid ' + statusDetails?.border_color,
                            color: statusDetails?.text_color,
                            borderRadius: 0
                        }}
                        className="w-[130px] text-center font-semibold">
                        {statusFull}
                    </Tag>
                </div>

                {isDefect && (
                    <>
                        {taskDescription && (
                            <div
                                style={{ border: '1.5px solid grey' }}
                                className="w-full h-[21.6px] bg-[#F9F9F9] mt-3 rounded-sm p-[2px] overflow-hidden">
                                {taskDescription}
                            </div>
                        )}
                        {failDescription && (
                            <div
                                style={{ border: '1.5px solid grey' }}
                                className="w-full h-[21.6px] bg-[#F9F9F9] mt-3 rounded-sm p-[2px] overflow-hidden">
                                {failDescription}
                            </div>
                        )}
                        {locationType && (
                            <div
                                style={{ border: '1.5px solid grey' }}
                                className="w-full h-[21.6px] bg-[#F9F9F9] mt-3 rounded-sm p-[2px] overflow-hidden">
                                {locationType}
                            </div>
                        )}
                    </>
                )}

                <div className="w-full flex gap-1 mt-3">
                    <div>Start Date</div>
                    <div style={{ border: '1.5px solid grey', padding: '2px' }} className="w-[130px] h-[21.6px] bg-[#F9F9F9] rounded-sm">
                        {formattedDate}
                    </div>
                </div>

                {supplier && (
                    <div style={{ border: '1px solid grey' }} className="w-full h-[21.6px] bg-[#F9F9F9] mt-3 rounded-sm p-[2px] overflow-hidden">
                        {supplier}
                    </div>
                )}

                <div className="w-full flex gap-2 mt-3">
                    <div className="w-[22%]">Vehicle</div>

                    <div className="w-[78%] flex flex-col gap-2">
                        <div className="w-full h-[21.6px] bg-[#F9F9F9] rounded-sm p-[2px] overflow-hidden" style={{ border: '1px solid grey' }}>
                            {vehicleReg}
                        </div>
                        <div style={{ border: '1px solid grey' }} className="w-full h-[21.6px] bg-[#F9F9F9] rounded-sm p-[2px] overflow-hidden">
                            {vehicleType}
                        </div>
                        <div style={{ border: '1px solid grey' }} className="w-full h-[21.6px] bg-[#F9F9F9] rounded-sm p-[2px] overflow-hidden">
                            {vehicleMake}
                        </div>
                    </div>
                </div>
                <button className="btn-action-in-popup" onClick={handleEditService}>
                    Edit {isDefect ? 'Defect' : isScheduled ? 'Scheduled Service' : 'Unscheduled Service'}
                </button>
                {workTicketId !== null && (
                    <button className="btn-action-in-popup" onClick={handleViewTicket}>
                        View Work Ticket
                    </button>
                )}
            </div>
        </div>
    );
};
